import SectionContainer from './SectionContainer'

export default SectionContainer
